import { render, staticRenderFns } from "./CreditReturn.vue?vue&type=template&id=2b184692&lang=pug"
import script from "./CreditReturn.vue?vue&type=script&lang=js"
export * from "./CreditReturn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports